// app.service.js

"use strict";

import angular from "angular";

import {DialogService} from "./app.dialog.services";
import {Fias} from "./core/kladr";

let bx = window.BX;

function BXDataService(bxDesktop, $q, $http) {

    var rulesMaster = [];
    var tootipsMaster = [];
    var rulesErrorsMaster = [];
    var rulesFilesMaster = [];
    this.variable = "This is public";
    
    this.getApplicant = function(id) {
        return  bxDesktop.action('applicant', {id:id})
    };

    this.getApplicants = function(){
        return bxDesktop.action('applicants')
    }

    this.saveApplicants = function(applicant){
        return  bxDesktop.action('save-applicant', {applicant:applicant})
    }

    this.saveBid = function(data){
        return  bxDesktop.action('save-bid', {bid:data})
    }

    this.sendBid = function(data){
        return  bxDesktop.action('send-bid', {bid:data})
    }
    this.sendAppeal = function(data){
        return  bxDesktop.action('send-appeal', {data:data})
    }

    this.sendTuDoc = function(data){
        return  bxDesktop.action('send-tudoc', {tudoc:data})
    }

    

    this.deleteApplicant = function(id){
        return  bxDesktop.action('delete-applicant', {id:id})
    }


    this.getAppeals = function(){
        return bxDesktop.action('appeals')
    }
   
    this.getSendedBids = function(){
        return bxDesktop.action('sended-bid')
    }

    this.getBids = function(){
        return bxDesktop.action('bids')
    }

    this.getBidsAjax= function(page, size, filter, order, orderBy){
        return bxDesktop.action('bids-ajax', {
            start:page,
            end:size,
            filter:filter,
            order:order,
            orderby:orderBy,
        })
    }

    this.getBidsFiles = function(){
        return bxDesktop.action('bids-files')
    }

    this.getAppealsFiles = function(){
        return bxDesktop.action('appeals-files')
    }

    this.getAppeal= function(id){
        return bxDesktop.action('appeal', {id:id})
    }
    
    this.getBid= function(id){
        return bxDesktop.action('bid', {id:id})
    }

    this.getBidDocs= function(id){
        return bxDesktop.action('bid-docs', {id:id})
    }

    this.getProjectDocs= function(id){
        return bxDesktop.action('project-docs', {id:id})
    }

    this.getClaimTU= function(id){
        return bxDesktop.action('claim-tu', {id:id})
    }
    
     
    this.annulBid = function(id, reason){
        return bxDesktop.action('annul-bid', {
            id:id,
            message:reason
        })
    }

    this.addExtFilesBid = function(id, files){
        return bxDesktop.action('add-ext-files-bid', {
            id:id,
            file:files
        })
    }

    this.addProjectDocs = function(bidId, id, files){
        return bxDesktop.action('add-project-docs', {
            bidId:bidId,
            docId:id,
            files:files
        })
    }

    this.deleteBid= function(id){
        return bxDesktop.action('delete-bid', {id:id})
    }
    this.getPayments = function(){
        return bxDesktop.action('payments')
    }

    this.getPaymentsBill = function(id){
        return bxDesktop.action('payments-bill',{id:id})
    }
    this.getPaymentsCheck = function(id){
        return bxDesktop.action('payments-check',{
            id:id,
            //payment:payment
        })
    }

    
    this.getPaymentsInvoice = function(id){
        return bxDesktop.action('payments-invoice',{id:id})
    }
    this.getPaymentsOnline = function(id){
        return bxDesktop.action('payments-online',{id:id})
    }
    this.getPaymentsDocs = function(id){
        return bxDesktop.action('payments-docs',{id:id})
    }
    this.getPaymentsReceipts = function(id){
        return bxDesktop.action('payments-receipts',{id:id})
    }

    this.getUserDocsNumers = function(){
        return bxDesktop.action('biddocs')
    }

    this.getNotifies = function(){
        return bxDesktop.action('notifies')
    }
    this.hideNotify = function(id){
        return bxDesktop.action('hide-notify',{id:id})
    }

    this.sendSignDoc = function(id, docID){
        bxDesktop.action('send-sign-doc', {
            id:id,
            docId:docID
        });
    }

    this.sendSignCodeDoc = function(id, docID, code){
        return bxDesktop.action('send-sign-code-doc', {
            id:id,
            docId:docID,
            code:code
        });
    }
	
	this.sendCommentDoc = function(id, docID, text){
		return bxDesktop.action('send-comment-doc', {
			id: id,
			docId: docID,
			text: text
		});
	}

    this.sendSignFileDoc = function(id, docID, file){
        return bxDesktop.action('send-sign-file-doc', {
            id:id,
            docId:docID,
            file:file
        });
    }

    

    this.getFilesRules = function(){
        var deffered= $q.defer();

        if(!rulesFilesMaster.length){
            bxDesktop.action('master-files').then(function(data){
                rulesFilesMaster = data;
                deffered.resolve(rulesFilesMaster);
            })
        }else{
            deffered.resolve(rulesFilesMaster);
        }
        
        
        return deffered.promise; 
    }
    this.getRules = function(){
        var deffered= $q.defer();

        if(!rulesMaster.length){
            bxDesktop.action('master-settings').then(function(data){
                rulesMaster = data;
                deffered.resolve(rulesMaster);
            })
        }else{
            deffered.resolve(rulesMaster);
        }
        
        
        return deffered.promise; 
    }


    this.getTootips = function(){
        var deffered= $q.defer();

        if(!tootipsMaster.length){
            bxDesktop.action('master-tootips').then(function(data){
                tootipsMaster = data;
                deffered.resolve(tootipsMaster);
            })
        }else{
            deffered.resolve(tootipsMaster);
        }
        
        
        return deffered.promise; 
    }
    
    
    this.getErrorsRules = function(){
        var deffered= $q.defer();

        if(!rulesErrorsMaster.length){
            bxDesktop.action('master-errors-settings').then(function(data){
                rulesErrorsMaster = data;
                deffered.resolve(rulesErrorsMaster);
            });
        }else{
            deffered.resolve(rulesErrorsMaster);
        }
        
        
        return deffered.promise; 
    }

    var servicesPrices = {} ;
    this.getServices = function(id){
        if(servicesPrices[id]){
            return servicesPrices[id];
        }
        servicesPrices[id] =  bxDesktop.action('services-price', {district:id})
        return servicesPrices[id] 
    }

    var services = null ;
    this.getServicesClear = function(){
        if(services){
            return services;
        }
        services = bxDesktop.action('services', {});
        return services;
    }


    this.getPdfAsHtml = function(bid, template, data){
        return bxDesktop.action('pdf', {
            id:bid,
            type:'html',
            template: template,
            params:data? JSON.stringify(data):''
        })
    }

    this.getPdf = function(bid, template){
        return bxDesktop.action('pdf', {
            id:bid,
            type:'pdf',
            template: template
        })
    }




    this.getInvoice = function(bidId, checkedBills){

        var deffered= $q.defer();

        var url = bx.util.add_url_param('/bitrix/services/main/ajax.php', {
            mode: 'class',
            c: 'cript:desktop',
            action: 'pdf',
            sessid:  bx.bitrix_sessid()
        });

        
        var response = $http.post(
            url,
            bx.util.buildQueryString(
                {
                    id: bidId,
                    type: 'pdf',
                    template: 'invoice-check',
                    params: JSON.stringify({payments:checkedBills}),
                    SITE_ID: bx.message.SITE_ID,
                    // sessid: bx.bitrix_sessid()
                }
            ), 
            {
                responseType:'arraybuffer',
                
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded',
                }
            }
        );


        
        response.then(function (data) {
            deffered.resolve(data);
        }, function(data){
            deffered.reject(data);
        })

        
        return deffered.promise; 

    }

    this.getReceipt = function(bidId, checkedBills){

        var deffered= $q.defer();

        var url = bx.util.add_url_param('/bitrix/services/main/ajax.php', {
            mode: 'class',
            c: 'cript:desktop',
            action: 'pdf',
            sessid:  bx.bitrix_sessid()
        });

        
        var response = $http.post(
            url,
            bx.util.buildQueryString(
                {
                    id: bidId,
                    type: 'pdf',
                    template: 'invoice-receipt',
                    params: JSON.stringify({payments:checkedBills}),
                    SITE_ID: bx.message.SITE_ID,
                    // sessid: bx.bitrix_sessid()
                }
            ), 
            {
                responseType:'arraybuffer',
                
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded',
                }
            }
        );


        
        response.then(function (data) {
            deffered.resolve(data);
        }, function(data){
            deffered.reject(data);
        })

        
        return deffered.promise; 

    }
    
    
    this.createYadFile = function(data){

       data.sessid = bx.bitrix_sessid();
       return $http.post(
                    "/local/components/cript/desktop/ajax.php?mode=upload-yad",
                    bx.util.buildQueryString(data),
                    {
                        headers: {
                            'Content-type': 'application/x-www-form-urlencoded',
                        }
                    }

       
        );
       
    }
    


    
}

function BXReferenceService(bxDesktop) {
    var references = {};
    var waitReference = {}

    function multiIndex(obj,is) {  
        return is.length ? multiIndex(obj[is[0]],is.slice(1)) : obj
    }
    function pathIndex(obj,is) {   
        return multiIndex(obj,is.split('.'))
    }



    this.getReference =  function(id) {
        id = id.toLowerCase();

        if(!references[id]){
            references[id] =  bxDesktop.action('reference', {entity:id});
        }


        return   references[id] ;
    };
    this.getAsyncReference = async function(id) {
       
        id = id.toLowerCase();

        if(!references[id]){
            references[id] =   await bxDesktop.action('reference', {entity:id});
        }


        return   references[id] ;
    };

    this.loadReference = async function(id) {
      
        id = id.toLowerCase();

        if(!references[id] && !waitReference[id]){

            if(!waitReference[id]){
                waitReference[id]=bxDesktop.action('reference', {entity:id})
            
            
                waitReference[id]
                    .then(function(data){
                        references[id] = data;
                    })
            }
           
        }

        return  waitReference[id];
    }

    
    this.getValue = function (path){
        return pathIndex(references, path);
    }

    this.loadReference('bid')
    

    
}

BXReferenceService.$inject =['bxDesktop'];
BXDataService.$inject =['bxDesktop', '$q', '$http'];

FiasService.$inject = ['$q']; 

function FiasService ($q){

    const fias = new Fias( ) ;
    var ajaxQueue = [];
    var clearAjaxQueue = function () {
        while (ajaxQueue.length > 5) {
            var a = ajaxQueue.shift();
            
            a.reject([]);
        }
    };


    this.getFias  = function(){
        return fias;
    }


    this.find= function(str, element,  fiasFields){
     
            
        var query = {
            token: 'Yk3sNi9E77Fh5KiHhYnyRfTBhbyS3GTt',
            limit: 10,
          //  withParent: true,
            type: element.type,
            contentType: element.type,
            withParent: true,
            query: str

        }, 
        
        callback = $q.defer(),
     
        founded=false, 
        parent = null 
        
        
        ;
      
        

        Fias.parents.forEach((type)=>{
            if(founded && !parent){
                parent = fiasFields.find(el=>el.type==type);
            }
            if(type== element.type){
                founded = true;
            }
        })
        
        
 
        

        if(parent){
            let parentVal = parent.value ; 
            if(!parentVal ){
                parentVal = parent.input?parent.input.val():null;
            }


            if(parentVal){
                query.parentType = parent.type;
                query.parentId = parentVal;
            }
           
        }

        clearAjaxQueue();
        ajaxQueue.push(callback)
    


        fias.api(query,callback) 
        return  callback.promise
        
        
/*
            var parentInput = get('parentInput'),
                parent;

            if (parentInput) {
                parent = getParent(parentInput, query.type);

                if (parent) {
                    query.parentType = parent.type;
                    query.parentId = parent.id;
                }
            }

            // Костыль для поиска одной строкой
            if (query.oneString) {
                query.withParents = true;
            }

            return query;
            */

        
    }


}
const SERVICE_MODULE = angular.module("moetp.services", [])
SERVICE_MODULE.service('BXReferenceService',BXReferenceService)
SERVICE_MODULE.service('BXDataService',BXDataService)
SERVICE_MODULE.service('FiasService',FiasService)
SERVICE_MODULE.service('DialogService',DialogService)
SERVICE_MODULE.service("UniqueIdService", function(){

    var nextId = 1;

    this.getUniqueId = function(){
        return nextId++;
    }
});
export { SERVICE_MODULE };



// WEBPACK FOOTER //
// ./src/app.services.js